import React from 'react';

export function Page404() {

    return (
      <>您沒有權限讀取此頁</>
    )
}